export default __webpack_public_path__ + "static/media/dozule3.57c29b07.jpg";